var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166626 6.0729V16.75C0.166626 18.4667 2.12655 19.4467 3.49996 18.4166L7.24996 15.6041C7.9907 15.0486 9.00922 15.0486 9.74996 15.6041L13.5 18.4166C14.8734 19.4467 16.8333 18.4667 16.8333 16.75V6.0729H0.166626ZM0.166626 4.5104H16.8333V2.16665C16.8333 1.01605 15.9006 0.083313 14.75 0.083313H2.24996C1.09937 0.083313 0.166626 1.01605 0.166626 2.16665V4.5104Z",
    fill: "#21367F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.16bed84a4d02b0cf58ae8f9046e7a422.svg";
export { ForwardRef as ReactComponent };